import infiniteScroll from 'vue-infinite-scroll';
import { isEqual } from 'lodash';
import VLoader from '@/components/Loader.vue';

export default {
  directives: {
    infiniteScroll,
  },
  components: {
    VLoader,
  },
  data() {
    return {
      search: {
        apiMethod: '',
        pagination: {
          page: 1,
          isLastPage: false,
          pageSize: 25,
          pageSizeDelta: 0,
        },
        filters: {},
        result: [],
        controller: null,
        isSearching: true,
        isAborted: false,
      },
    };
  },
  methods: {
    async performSearch() {
      if (this.search.isSearching && this.search.controller) {
        this.search.controller.abort();
        this.search.isAborted = true;
      }

      this.search.isSearching = true;

      this.search.controller = new AbortController();
      try {
        const response = await this.$api[this.search.apiMethod]({
          ...this.search.filters,
          start: (this.search.pagination.page - 1) * this.search.pagination.pageSize + this.search.pagination.pageSizeDelta,
          length: this.search.pagination.pageSize,
        }, { signal: this.search.controller.signal });

        if (response.length < this.search.pagination.pageSize) {
          this.search.pagination.isLastPage = true;
        }

        this.search.result.push(...response);
      } finally {
        if (!this.search.isAborted) {
          this.search.isSearching = false;
        }

        this.search.isAborted = false;
      }
    },
    loadFirstSearchPage() {
      this.search.pagination.page = 1;
      this.search.result = [];
      this.search.pagination.isLastPage = false;
      this.performSearch();
    },
    loadNextSearchPage() {
      if (this.search.isSearching || this.search.pagination.isLastPage) {
        return;
      }

      this.search.pagination.page = this.search.pagination.page + 1;
      this.performSearch();
    },
  },
  watch: {
    'search.filters': {
      handler(newValue, oldValue) {
        if (isEqual(newValue, oldValue)) {
          return;
        }

        this.loadFirstSearchPage();
      },
      deep: true,
    },
  },
  created() {
    this.performSearch();
  },
};
